import * as React from "react";
import { Navigate } from "react-router-dom";

export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: React.ReactElement;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
}: ProtectedRouteProps) {
  const token = localStorage.getItem("access_token");
  
  if (token && token !== "null" && token !== "undefined") {
    return outlet;
  } else {
    localStorage.clear();
    return <Navigate to={authenticationPath} replace />;
  }
}
